import {ComponentProps, PropsWithChildren} from "react";
import {GroupBase, SelectComponentsConfig} from "react-select";
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {outlinedChip} from "../../../../styles/receipes/outlined_chip";

type RemoveProps = ComponentProps<
    Exclude<SelectComponentsConfig<IOption<number>, boolean, GroupBase<IOption<number>>>["MultiValue"], undefined>
>["removeProps"];

interface IProps extends PropsWithChildren {
    neutral?: boolean;
    removeProps?: RemoveProps;
}

export const HomeMatchUserPreferencesLocationPill = (props: IProps) => {
    const {children, neutral = false, removeProps} = props;
    const chipStyle = neutral ? (removeProps ? neutralWrapperStyle : neutralCountStyle) : wrapperStyle;

    return (
        <div className={chipStyle} data-testid={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_PILL}>
            <Text
                as="div"
                className={neutral ? neutralTextStyle : textStyle}
                color={neutral ? "var(--colors-secondary)" : undefined}
                preserveFontSize={neutral}
                variant="info_txt_1"
            >
                {children}
            </Text>
            {removeProps && (
                <div {...removeProps} className={removeActionStyle}>
                    <CloseIcon className={neutral ? removeIconStyle : undefined} size={neutral ? undefined : "1.4"} />
                </div>
            )}
        </div>
    );
};

const pillLayout = css.raw({
    alignItems: "center",
    display: "flex"
});

const wrapperStyle = css(pillLayout, {
    backgroundColor: "var(--colors-primary)",
    borderRadius: 2,
    gap: 1,
    px: 1,
    py: 0.5
});

const neutralChipStyle = css.raw(outlinedChip, {
    gap: 0.5
});

const neutralWrapperStyle = css(pillLayout, neutralChipStyle, {
    maxWidth: "100%",
    minWidth: 0,
    overflow: "hidden"
});

const neutralCountStyle = css(pillLayout, neutralChipStyle, {
    flexShrink: 0
});

const textStyle = css(pillLayout, {
    minHeight: "1.6rem"
});

const neutralTextStyle = css({
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const removeActionStyle = css(pillLayout, {
    cursor: "pointer",
    justifyContent: "center"
});

const removeIconStyle = css({
    height: "1.2rem",
    transform: "none",
    width: "1.2rem"
});
import {ComponentProps, PropsWithChildren} from "react";
import {GroupBase, SelectComponentsConfig} from "react-select";
import {css} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {outlinedChip} from "../../../../styles/receipes/outlined_chip";

type RemoveProps = ComponentProps<
    Exclude<SelectComponentsConfig<IOption<number>, boolean, GroupBase<IOption<number>>>["MultiValue"], undefined>
>["removeProps"];

interface IProps extends PropsWithChildren {
    neutral?: boolean;
    removeProps?: RemoveProps;
}

export const HomeMatchUserPreferencesLocationPill = (props: IProps) => {
    const {children, neutral = false, removeProps} = props;
    const chipStyle = neutral ? (removeProps ? neutralWrapperStyle : neutralCountStyle) : wrapperStyle;

    return (
        <div className={chipStyle} data-testid={KM_PREFERENCES_FORM_TEST_IDS.LOCATION_PILL}>
            <Text
                as="div"
                className={neutral ? neutralTextStyle : textStyle}
                color={neutral ? "var(--colors-secondary)" : undefined}
                preserveFontSize={neutral}
                variant="info_txt_1"
            >
                {children}
            </Text>
            {removeProps && (
                <div {...removeProps} className={removeActionStyle}>
                    <CloseIcon className={neutral ? removeIconStyle : undefined} size={neutral ? undefined : "1.4"} />
                </div>
            )}
        </div>
    );
};

const pillLayout = css.raw({
    alignItems: "center",
    display: "flex"
});

const wrapperStyle = css(pillLayout, {
    backgroundColor: "var(--colors-primary)",
    borderRadius: 2,
    gap: 1,
    px: 1,
    py: 0.5
});

const neutralChipStyle = css.raw(outlinedChip, {
    gap: 0.5
});

const neutralWrapperStyle = css(pillLayout, neutralChipStyle, {
    maxWidth: "100%",
    minWidth: 0,
    overflow: "hidden"
});

const neutralCountStyle = css(pillLayout, neutralChipStyle, {
    flexShrink: 0
});

const textStyle = css(pillLayout, {
    minHeight: "1.6rem"
});

const neutralTextStyle = css({
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});

const removeActionStyle = css(pillLayout, {
    cursor: "pointer",
    justifyContent: "center"
});

const removeIconStyle = css({
    height: "1.2rem",
    transform: "none",
    width: "1.2rem"
});
